export enum ResponseMessageTypeEnum {
    info = 'info',
    success = 'success',
    warning = 'warning',
    error = 'error',
    fieldValidationError = 'fieldValidationError',
    sapError = 'sapError',
    critical = 'critical',
}
